module.exports = __webpack_public_path__ + "static/media/sign-icon.6b106cf0.svg";